<template>
  <section class="social-media-section">
    <div class="container">
      <div class="social-content">
        <h2 class="section-title">
          تابعنا على السوشيال ميديا
        </h2>
        
        <h3 class="section-subtitle">
            كل <span class="hero-subtext">منصات</span> مستر أحمد مكاوي
            <br/> في مكان واحد  
        </h3>
        
        <!-- الوصف -->
        <p class="section-description">
          تابع المحتوى الحصري، الفيديوهات، الأخبار، وكل جديد على جميع قنوات التواصل الاجتماعي الرسمية
        </p>
        
        <div class="social-icons">
            <a href="tel:201118500056" class="social-icon" target="_blank" rel="noopener noreferrer">
                <img src="@/assets/images/5.svg" alt="phone" class="icon-img">
            </a>
            <a href="https://www.instagram.com/mr.mekawy1?igsh=M2w2ZWxlbzl3N3Qx" class="social-icon" target="_blank" rel="noopener noreferrer">
                <img src="@/assets/images/4.svg" alt="instagram" class="icon-img">
            </a>
            <a href="https://www.tiktok.com/@mrmekawy1?_t=ZS-8yBxula4g6i&_r=1" class="social-icon" target="_blank" rel="noopener noreferrer">
                <img src="@/assets/images/3.svg" alt="tiktok" class="icon-img">
            </a>
            <a href="https://t.me/geoahmedmekawy" class="social-icon" target="_blank" rel="noopener noreferrer">
                <img src="@/assets/images/6.svg" alt="telegram" class="icon-img">
            </a>
            <a href="https://youtube.com/@mrahmedmekawy?si=ecTpUazwpGGpgs0M" class="social-icon" target="_blank" rel="noopener noreferrer">
                <img src="@/assets/images/7.svg" alt="youtube" class="icon-img">
            </a>
            <a href="https://www.facebook.com/share/19W1UsQ4yM/?mibextid=qi2Omg" class="social-icon" target="_blank" rel="noopener noreferrer">
                <img src="@/assets/images/2.svg" alt="facebook" class="icon-img">
            </a>
            <a href="https://whatsapp.com/channel/0029Vb6b9ra4SpkAunejCI1s" class="social-icon" target="_blank" rel="noopener noreferrer">
                <img src="@/assets/images/1.svg" alt="whatsapp" class="icon-img">
            </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'SocialMediaSection',
  data() {
    return {
      socialLinks: {
        facebook: '#',
        youtube: '#',
        instagram: '#',
        tiktok: '#',
        telegram: '#',
        whatsapp: '#',
        phone: '#'
      }
    }
  }
}
</script>

<style>
.social-media-section {
  padding: 200px 0;
  background: #EFF1F4;
  text-align: center;
  direction: rtl;
}

.social-content {
    background: linear-gradient(217deg, rgba(0, 190, 171, 0.6) 0%, rgba(0, 190, 171, 0.25) -6%, rgba(255, 239, 214, 1) 52%, rgba(255, 157, 0, 0.4) 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 48px;
padding: 48px;
}

.section-title {
  font-size: 22px;
  font-weight: 400;
  color: #FF9A18;
  margin-bottom: 15px;
  line-height: 1.2;
  text-align: center;
}

.section-subtitle {
  font-size: 54px;
  font-weight: 600;
  color: #000;
  margin: 30px 0;
  line-height: 1.4;
}

.section-description {
  font-size: 22px;
  font-weight: 400;
  color: #7F8685;
  margin: 0;
  
}

.social-icons {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 32px;
  margin-top: 40px;
}

.social-icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
  transition: all 0.3s ease;
}

.social-icon:hover {
  transform: translateY(-5px);
}

.icon-img {
  width: 50px;
  height: 50px;
  margin-bottom: 10px;
  transition: transform 0.3s ease;
}
@media (max-width: 992px) {
  .social-media-section {
    padding: 60px 0;
  }
  
  .social-icons {
    gap: 20px;
  }
  
  .social-icon {
    padding: 15px;
    min-width: 90px;
  }
  
  .icon-img {
    width: 45px;
    height: 45px;
  }
  
  .social-stats {
    gap: 30px;
    padding: 25px;
  }
}

@media (max-width: 768px) {
  .social-content {
    gap: 25px;
    padding: 40px 0;
  }
  
  .social-icons {
    gap: 15px;
  }
  
  .social-icon {
    padding: 12px;
    min-width: 80px;
    border-radius: 15px;
  }
  
  .icon-img {
    width: 40px;
    height: 40px;
  }
  
  .icon-label {
    font-size: 0.9rem;
  }
  
  .social-stats {
    gap: 25px;
    padding: 20px;
  }
  
  .stat-item {
    min-width: 80px;
  }
}

@media (max-width: 576px) {
    .section-subtitle {
        font-size: 30px;
          line-height: 1.5;

    }
    .section-description {
        font-size: 18px;
    }
  .social-media-section {
    padding: 40px 0;
  }
  
  .social-icons {
    gap: 10px;
  }
  
  .social-icon {
    padding: 10px;
    min-width: 70px;
    border-radius: 12px;
  }
  
  .icon-img {
    width: 35px;
    height: 35px;
  }


}

/* شاشات صغيرة جداً */
@media (max-width: 400px) {
  .social-icons {
    gap: 8px;
  }
  
  .social-icon {
    min-width: 65px;
    padding: 8px;
  }
  
  .icon-img {
    width: 30px;
    height: 30px;
  }
  
  .icon-label {
    font-size: 0.75rem;
  }
}
</style>